/**
 * Utility to manage environment-aware logging.
 *
 * It overrides global console methods to silence them in production environments.
 * It also provides a way to force logs in production via console.important.
 */
export const initLogger = () => {
  const env = process.env.REACT_APP_ENV;
  const isProduction = env === 'production';

  // Save original methods to allow "important" logs or for restoration if needed (internal use)
  const originalConsole = {
    log: console.log,
    info: console.info,
    debug: console.debug,
    warn: console.warn,
    error: console.error,
  };

  // Define the exception method "important"
  // Usage: console.important('This will always show', someData);
  console.important = (...args) => {
    originalConsole.log.apply(console, ['[IMPORTANT]', ...args]);
  };

  if (isProduction) {
    // Silence logs in production
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};

    // Note: console.warn and console.error are kept by default.
    // If you want to silence them too, uncomment below:
    // console.warn = () => {};
    // console.error = () => {};

    // Optional: Log a message indicating logs are silenced (only visible if we didn't silence log... wait we did :D)
    // So we use the original console to verify it initialized if debug needed.
    // originalConsole.log('Logger initialized in PRODUCTION mode. Logs silenced.');
  } else {
    // Development / Staging
    // We can add a custom welcome message
    console.log(`Logger initialized in ${env || 'development'} mode.`);
  }
};
